import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FormInputTextProps } from 'features/common/components/Form/types';
import { InputToggle } from '../InputToggle/InputToggle';
import { Error } from 'features/common/components/Form/Form.styles';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { InputContainer, StyledQuillWrapper } from './RichTextInput.styles';

export const RichTextInput = ({ id, name, label, isPunchup = false }: FormInputTextProps & { isPunchup?: boolean }) => {
	const {
		setValue,
		watch,
		formState: { errors },
	} = useFormContext();

	const error = errors[name as keyof typeof errors];
	const value: string = watch(name as string) || '';

	const modules = useMemo(
		() => ({
			toolbar: [
				[{ header: [1, 2, 3, 4, 5, false] }],
				['bold', 'italic', 'underline', 'strike', 'blockquote'],
				[{ color: [] }, { background: [] }],
				[{ list: 'ordered' }, { list: 'bullet' }],
				[{ align: [] }],
				['link', 'clean'],
			],
			clipboard: { matchVisual: false },
		}),
		[]
	);

	const formats = useMemo(
		() => [
			'header',
			'bold',
			'italic',
			'underline',
			'strike',
			'blockquote',
			'color',
			'background',
			'list',
			'bullet',
			'align',
			'link',
			'clean',
		],
		[]
	);

	return (
		<InputContainer hasError={Boolean(error)} isPunchup={isPunchup}>
			<InputToggle htmlFor={id ?? name} label={label} name={`${name}Enabled`} isPunchup={isPunchup} />
			<StyledQuillWrapper isPunchup={isPunchup}>
				<ReactQuill
					id={id ?? name}
					theme="snow"
					value={value}
					modules={modules}
					formats={formats}
					onChange={(html) => setValue(name as string, html, { shouldDirty: true })}
				/>
			</StyledQuillWrapper>
			<Error>{(error as any)?.message}</Error>
		</InputContainer>
	);
};
